export default __webpack_public_path__ + "static/media/checklist.6da86d46.png";